import type { CSSProperties, ReactNode } from 'react';

export interface ListRowProps {
  children: ReactNode;
  /** Draws the hairline above. Pass `index > 0` for all but the first row. */
  divider?: boolean;
  onClick?: () => void;
  style?: CSSProperties;
}

/** One row inside a flush Card. Becomes a button when given an onClick. */
export function ListRow({ children, divider = false, onClick, style }: ListRowProps) {
  const shared: CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: 'var(--sp-3)',
    width: '100%',
    padding: 'var(--sp-4) var(--sp-5)',
    borderTop: divider ? '1px solid var(--border)' : 'none',
    textAlign: 'left',
    ...style,
  };

  if (!onClick) return <div style={shared}>{children}</div>;

  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        ...shared,
        background: 'none',
        border: 'none',
        borderTop: shared.borderTop,
        cursor: 'pointer',
        font: 'inherit',
        color: 'inherit',
      }}
    >
      {children}
    </button>
  );
}

export interface IconTileProps {
  children: ReactNode;
  size?: number;
  background?: string;
  color?: string;
}

/** The mint rounded square behind a category or person glyph. */
export function IconTile({
  children,
  size = 42,
  background = 'var(--accent-soft)',
  color = 'var(--accent)',
}: IconTileProps) {
  return (
    <div
      style={{
        width: size,
        height: size,
        flex: '0 0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background,
        color,
        borderRadius: Math.round(size * 0.3),
      }}
    >
      {children}
    </div>
  );
}
